import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Typography, CircularProgress } from '@material-ui/core'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import { getNoticeById } from 'src/services/api/WebApi/Notices/notices.service'
import { Notice } from 'src/services/api/WebApi/Notices/notices.types'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './OpportunitiesDetailsContent.styles'

interface RouteParams {
  id: string
}
const OpportunitiesDetailsContent = () => {
  const { id } = useParams<RouteParams>()
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const [notice, setNotice] = useState<Notice | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    const fetchNotice = async () => {
      try {
        setIsLoading(true)
        const data = await getNoticeById(id)
        setNotice(data)
      } catch (error) {
        console.error('Erro ao carregar edital:', error)
      } finally {
        setIsLoading(false)
      }
    }
    fetchNotice()
  }, [id])
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="70vh"
      >
        <CircularProgress />
      </Box>
    )
  }
  if (!notice) {
    return null
  }
  return (
    <Box className={globalClasses.containerPages}>
      <BreadcrumbsComponent
        crumbs={[
          { label: t('navbar.start'), path: '/' },
          { label: t('navbar.opportunities'), path: '/opportunities' },
          { label: notice.title }
        ]}
      />
      <Box className={classes.container}>
        <Typography className={globalClasses.titleSectionVariant2}>
          {notice.title}
        </Typography>
        <Box
          className={classes.description}
          dangerouslySetInnerHTML={{
            __html:
              notice.description ||
              notice.text ||
              notice.content ||
              `<p>${t('notices.no-description')}</p>`
          }}
        />
        <Box className={classes.applySection}>
          <Typography className={globalClasses.titleSectionVariant2}>
            {t('notices.how-to-apply')}
          </Typography>
          <Box className={classes.applyBox}>
            <Typography className={classes.applyText}>
              {t('notices.apply-email')} <strong>jobs@lsbd.ufc.br</strong>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default OpportunitiesDetailsContent
